import axios from "axios";
import { sessionExpired, touch, endSession } from "@/lib/session";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BASE}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("os_token");
  if (token && sessionExpired() && !config.url.includes("/auth/login")) {
    endSession("Sua sessão expirou por inatividade. Entre novamente.");
    return Promise.reject(new axios.Cancel("session-expired"));
  }
  if (token) { config.headers.Authorization = `Bearer ${token}`; touch(); }
  const tenant = localStorage.getItem("os_tenant");
  if (tenant) config.headers["X-Tenant-Id"] = tenant;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login")) endSession("Sua sessão expirou. Entre novamente para continuar.");
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = "Erro inesperado") => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};

export const STATUSES = ["Aberta", "Em Atendimento", "Aguardando Cliente", "Aguardando Material", "Resolvida", "Finalizada", "Cancelada"];

export const STATUS_STYLES = {
  Aberta: "bg-amber-500/10 text-amber-600 dark:text-amber-400 border-amber-500/30",
  "Em Atendimento": "bg-blue-500/10 text-blue-600 dark:text-blue-400 border-blue-500/30",
  "Aguardando Cliente": "bg-purple-500/10 text-purple-600 dark:text-purple-400 border-purple-500/30",
  "Aguardando Material": "bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30",
  Resolvida: "bg-teal-500/10 text-teal-600 dark:text-teal-400 border-teal-500/30",
  Finalizada: "bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30",
  Cancelada: "bg-rose-500/10 text-rose-600 dark:text-rose-400 border-rose-500/30",
};

export const STATUS_COLORS = {
  Aberta: "#F59E0B", "Em Atendimento": "#3B82F6", "Aguardando Cliente": "#A855F7",
  "Aguardando Material": "#F97316", Resolvida: "#14B8A6", Finalizada: "#10B981", Cancelada: "#EF4444",
};

export const PRIORITIES = ["Baixa", "Normal", "Alta", "Urgente"];
export const PRIORITY_STYLES = {
  Baixa: "bg-slate-500/10 text-slate-600 border-slate-500/30",
  Normal: "bg-sky-500/10 text-sky-600 border-sky-500/30",
  Alta: "bg-orange-500/10 text-orange-600 border-orange-500/30",
  Urgente: "bg-rose-500/10 text-rose-600 border-rose-500/30",
};

export const ROLES = {
  TENANT_ADMIN: "Administrador",
  SUPERVISOR: "Supervisor",
  ATENDENTE: "Atendente",
  CONSULTA: "Consulta",
  SUPER_ADMIN: "Super Admin",
};

export const PERMISSION_LABELS = {
  create_os: "Criar OS",
  view_os: "Visualizar OS",
  edit_os: "Editar OS",
  reply_customer: "Responder cliente",
  change_status: "Alterar status",
  delete_os: "Excluir OS",
  assign_os: "Distribuir/Atribuir OS",
  manage_users: "Gerenciar usuários",
  manage_queues: "Gerenciar filas",
  manage_channels: "Gerenciar canais",
  manage_settings: "Configurações",
  reports: "Relatórios",
};

export const fmtDate = (v) => (v ? new Date(v).toLocaleString("pt-BR") : "—");
export const fileUrl = (url) => {
  if (!url) return url;
  const path = url.replace(/^https?:\/\/[^/]+/, "");
  const token = encodeURIComponent(localStorage.getItem("os_token") || "");
  return `${path}${path.includes("?") ? "&" : "?"}token=${token}`;
};
